import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, EDUCATION, } from './types';
import { GoBackAction, needHelpAction, onChangeInput, onSelect, setQualification, toggleCTA, triggerCTA, } from "./actions";
import { getContactUsDetails, getLenderInfo, horizontalStepperRepo, removeUrlWithoutReload } from '../../../configs/utils';
import { getAppHeader } from '../../../configs/config';
import { api } from '../../../configs/api';
import _ from 'lodash';
import SharedPropsService from '../../../SharedPropsService';
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
const qualificationInputData = [
    { label: 'Up to 12', value: EDUCATION.UP_TO_12 },
    { label: 'Diploma', value: EDUCATION.DIPLOMA },
    { label: 'Graduate', value: EDUCATION.UNDER_GRADUATE },
    { label: 'Post graduate', value: EDUCATION.POST_GRADUATE },
    { label: 'MBA', value: EDUCATION.MBA },
    { label: 'PHD', value: EDUCATION.PHD },
    { label: 'Professional', value: EDUCATION.PROFESSIONAL },
    { label: 'Others', value: EDUCATION.OTHERS },
];
const qualificationDataMap = new Map(qualificationInputData.map((obj) => [obj.value, obj]));
export const template = (stepper, stepResponseObject, fatherFirstName, fatherLastName, motherFirstName, motherLastName, qualification, maritalStatus, height, lenderName, incomeRange, purposeOfLoan, isFromJupiter, contactUsDetails, employmentStatus, sourceOfIncome) => {
    return {
        layout: {
            id: ROUTE.KYC_ADDITIONAL_DETAILS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "kycPage", type: WIDGET.KYC_ADDITIONAL_DETAILS_PAGE }
            ],
        },
        datastore: {
            kycPage: {
                contactUsDetails: contactUsDetails,
                height: height,
                stepperData: stepper,
                qualification: qualification,
                mothersFirstName: motherFirstName,
                mothersLastName: motherLastName,
                fathersFirstName: fatherFirstName,
                fathersLastName: fatherLastName,
                incomeRange: incomeRange,
                employmentStatus: employmentStatus,
                purposeOfLoan: purposeOfLoan,
                sourceOfIncome: sourceOfIncome,
                applyAction: {
                    type: ACTION.TRIGGER_CTA,
                    routeId: ROUTE.KYC_ADDITIONAL_DETAILS,
                    payload: {}
                },
                backAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.KYC_ADDITIONAL_DETAILS,
                    payload: {},
                },
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.KYC_ADDITIONAL_DETAILS,
                    payload: {},
                },
                lenderName: lenderName,
                loading: false,
                isFromJupiter: isFromJupiter
            },
        },
    };
};
export const kycAdditionalDetailsMF = {
    onLoad: async ({ getHeight, network }) => {
        const stepper = await horizontalStepperRepo(network);
        const user = await SharedPropsService.getUser();
        const userContextResponse = await network.post(api.userContext, {}, {
            headers: await getAppHeader(),
        });
        await SharedPropsService.setUser(userContextResponse?.data);
        let applicationId;
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const response = await network.get(`${api.additionalDetails}${applicationId}`, { headers: await getAppHeader() });
        // update application object with latest application details
        user.linkedApplications[0] = response?.data?.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        const stepResponseObject = _.get(response, 'data.stepResponseObject', {});
        const fatherFirstName = stepResponseObject.fatherFirstName || '';
        const fatherLastName = stepResponseObject.fatherLastName || '';
        const motherFirstName = stepResponseObject.motherFirstName || '';
        const motherLastName = stepResponseObject.motherLastName || '';
        let qualification = stepResponseObject.qualification || '';
        const maritalStatus = stepResponseObject.maritalStatus || '';
        const incomeRange = stepResponseObject?.incomeRange || '';
        const purposeOfLoan = stepResponseObject?.purposeOfLoan || '';
        const employmentStatus = stepResponseObject?.employmentStatus;
        const sourceOfIncome = stepResponseObject?.sourceOfIncome;
        const useOfLoan = stepResponseObject?.useOfLoan;
        const lenderInfo = await getLenderInfo(network);
        const lenderName = lenderInfo.lenderAccountId;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        if (qualificationDataMap.has(qualification)) {
            const existingQualification = qualificationDataMap.get(qualification);
            qualification = existingQualification.value;
            await setQualification(qualification);
        }
        else {
            qualification = '';
        }
        Platform.OS === 'web' ? removeUrlWithoutReload("message") : {};
        const contactUsDetails = await getContactUsDetails();
        return Promise.resolve(template(stepper, stepResponseObject, fatherFirstName, fatherLastName, motherFirstName, motherLastName, qualification, maritalStatus, getHeight(), lenderName, incomeRange, purposeOfLoan, isFromJupiter, contactUsDetails, employmentStatus, sourceOfIncome));
    },
    actions: {
        [ACTION.TRIGGER_CTA]: triggerCTA,
        [ACTION.STATUS_CHECK]: toggleCTA,
        [ACTION.STATUS_UNCHECK]: toggleCTA,
        [ACTION.INPUT_NAME]: onChangeInput,
        [ACTION.SELECT_QUALIFICATION]: onSelect,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
    },
};
